"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SoulModule = require('./SoulModule');
/**
* Manage user profile and access user products
* @extends SoulModule
*/


var Me =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Me, _SoulModule);

  function Me() {
    _classCallCheck(this, Me);

    return _possibleConstructorReturn(this, _getPrototypeOf(Me).apply(this, arguments));
  }

  _createClass(Me, [{
    key: "get",

    /**
    * get user profile
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.me.get
    * @example soul.me.get(() => {// do something aftre fetching me})
    */
    value: function get(callback) {
      return this.api.get(function (res) {
        return res;
      }, 'me', callback);
    }
    /**
    * Get list of bundles that user bought, and items in user inventory
    * This method duplicates  soul.purchases.getOwnedProducts and not use at pure.sex
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.me.getProducts
    * @example soul.me.getProducts()
    */

  }, {
    key: "getProducts",
    value: function getProducts(callback) {
      return this.api.get('purchases/my', callback);
    }
    /**
    * Get a list of user's subscriptions.
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.me.getSubscriptions
    * @example soul.me.getSubscriptions()
    */

  }, {
    key: "getSubscriptions",
    value: function getSubscriptions(callback) {
      return this.api.get(function (res) {
        return res.me.subscriptionServices;
      }, 'me', callback).then(function (subscriptionServices) {
        return subscriptionServices || {};
      });
    }
    /**
    * update user profile
    * @param {Object} params
    * @param {Object} params.filterable
    * These parameters are predefined in you application configuration and are used when finding users. They affect sorting and can be used to filter results, if neccesary. Some of this parameters can be set up to be defined only once (you can use it for gender, for example)
    * @param {Object} params.publicVisible
    * These parameters are schemaless, you can set any named parameters here. These parameters can be set only by current user, but are visible to everyone.
    * @param {Object} params.publicWritable
    * Schemaless as above ones, visible by all users and also can be set by any user. Useless for storing settings shared among multple users
    * @param {Object} params.private
    * Save as publicVisible, but these parameters can be set and viewed by current user only. No one else can see them. Usefull for storing app settings.
    * @param {function} [callback]
    * @return {Promise}
    * @soulsdk soul.me.update
    * @example soul.me.update({
    *   filterable: {
    *      lookingFor: 'f',
    *      gender: 'm'
    *   }
    * })
    */

  }, {
    key: "update",
    value: function update(parameters, callback) {
      return this.api.patch(function (res) {
        return {
          // Legacy, remove after refactor me
          parameters: res.me.parameters,
          additionalInfo: res.additionalInfo || {},
          me: res.me || {}
        };
      }, 'me', {
        parameters: parameters
      }, callback);
    }
  }, {
    key: "updateEmailsSubscriptionStatus",
    value: function updateEmailsSubscriptionStatus(_ref) {
      var unsubscribedStatus = _ref.unsubscribedStatus;
      return this.api.patch('users_params/me/', {
        emails_unsubscribed: unsubscribedStatus
      });
    }
  }, {
    key: "updateAnnouncement",
    value: function updateAnnouncement(_ref2) {
      var announcement = _ref2.announcement;
      return this.api.patch('me/announcement', {
        announcement: announcement
      });
    }
  }, {
    key: "updateAnnouncementNew",
    value: function updateAnnouncementNew(_ref3) {
      var announcement = _ref3.announcement;
      return this.api.patch('announcements/first/', {
        text: announcement
      });
    }
  }, {
    key: "getAnnouncements",
    value: function getAnnouncements() {
      return this.api.get('announcements/');
    }
  }, {
    key: "publishAnnouncement",
    value: function publishAnnouncement() {
      return this.api.post('announcements/first/publish/');
    }
  }, {
    key: "unpublishAnnouncement",
    value: function unpublishAnnouncement() {
      return this.api.post('announcements/first/unpublish/');
    }
  }, {
    key: "setPhotosOrder",
    value: function setPhotosOrder(data) {
      return this.api.post('announcements/first/photos/set_order/', {
        ids: data
      });
    }
  }, {
    key: "getMeParams",
    value: function getMeParams() {
      return this.api.get('users_params/me/');
    }
  }, {
    key: "deleteAccount",
    value: function deleteAccount() {
      return this.api["delete"]('v2_users/me/');
    }
    /**
    * update user profile
    * @param {Object} params
    * @return {Promise}
    * @soulsdk soul.me.updateProfile
    * @example soul.me.updateProfile({
    *   spoken_languages: ['ru', 'en']
    * })
    */

  }, {
    key: "updateProfile",
    value: function updateProfile(params) {
      return this.api.patch('v2_users/me/', params);
    }
  }]);

  return Me;
}(SoulModule);

module.exports = Me;